import React from 'react';
import { useIntl } from 'react-intl';

import { ActivateProductSidebar } from '@futrli/billing';
import { PREDICT_PRODUCT_SLUG } from '@futrli/shared-services';

interface OrganisationActivationSidebarProps {
  isOpen: boolean;
  onClose: () => void;
  workspaceId: string;
  organisationId: string;
}

export const OrganisationActivationSidebar = ({
  isOpen,
  onClose,
  workspaceId,
  organisationId
}: OrganisationActivationSidebarProps) => {
  const intl = useIntl();

  return (
    <ActivateProductSidebar
      isOpenDialog={isOpen}
      onCancel={onClose}
      onSuccess={() => window.location.reload()}
      workspaceId={workspaceId}
      organisationId={organisationId}
      productSlug={PREDICT_PRODUCT_SLUG}
      defaultMessage={intl.formatMessage({
        id: 'billing.subscription_inactive',
        defaultMessage:
          "Your subscription is currently not active. If you would like to activate your subscription and begin using Futrli, click 'Subscribe'."
      })}
    />
  );
};
